"use client";

import { HStack, Text, Button } from "@chakra-ui/react";
import type { ChatBotMessage } from "../types";

interface ChatbotMessageReactionsProps {
  msg: ChatBotMessage;
  addReaction: (id: number, emoji: string) => void;
  // handleSendMessage: (text: string, retryId?: number) => void;
  handleSendMessage: (params: { text: string; retryId?: number }) => void;
}

export default function ChatbotMessageReactions({
  msg,
  addReaction,
  handleSendMessage,
}: ChatbotMessageReactionsProps) {
  return (
    <>
      <HStack mt="1" spaceX={1}>
        {["👍", "❤️", "😆"].map((emoji) => (
          <Button
            key={emoji}
            size="xs"
            variant="ghost"
            onClick={() => addReaction(msg.id, emoji)}
          >
            {emoji}
          </Button>
        ))}
      </HStack>
      {msg.reactions && msg.reactions.length > 0 && (
        <Text fontSize="xs" mt="1">
          {msg.reactions.join(" ")}
        </Text>
      )}
      {msg.sender === "user" && msg.status === "error" && (
        <Button
          size="xs"
          mt="1"
          // onClick={() => handleSendMessage(msg.text, msg.id)}
          onClick={() => handleSendMessage({ text: msg.text, retryId: msg.id })}
        >
          Retry
        </Button>
      )}
    </>
  );
}
